import videojs from 'video.js';
import './button-play';
import './button-seek';
import './bubble.js';

const Plugin = videojs.getPlugin('plugin');

const defaultOptions = {
	iconsUrl: null,
	seekValue: 10,
	breakpoints: ['1024', '812', '768', '480'],
	isEnableDoubleClick: false,
	uiConfig: {
		showBigPlayButton: true
	}
};

export default class BigControls extends Plugin {
	constructor(player, options) {
		super(player);

		const mergedOptions = videojs.mergeOptions(defaultOptions, options);
		this.ui = {};

		this.bubbleForwardTimeoutId;
		this.bubbleBackwardTimeoutId;

		this.player.ready(() => {
			this.player.addClass('vjs-big-controls');

			if (mergedOptions.isEnableDoubleClick) {
				this.player.addClass('vjs-big-controls_enabled-double-click');
			}

			if (mergedOptions.uiConfig.showBigPlayButton) {
				this.ui.buttonPlay = this.player.addChild('ButtonPlay', mergedOptions, player.children_.length);
			}

			if (!mergedOptions.seekValue) return;

			this.ui.bubbleForward = this.player.addChild('BigControlsBubble', {
				innerText: `+${mergedOptions.seekValue} сек`,
				direction: 'forward'
			});
			this.ui.bubbleBackward = this.player.addChild('BigControlsBubble', {
				innerText: `-${mergedOptions.seekValue} сек`,
				direction: 'backward'
			});

			this.ui.buttonSeekForward = this.player.addChild('ButtonSeek',
				videojs.mergeOptions(
					mergedOptions,
					{
						isEnableDoubleClick: mergedOptions.isEnableDoubleClick,
						value: mergedOptions.seekValue,
						onClick: () => this.showBubble(this.ui.bubbleForward, this.bubbleForwardTimeoutId)
					}
				),
				player.children_.length
			);
			this.ui.buttonSeekBackward = this.player.addChild('ButtonSeek',
				videojs.mergeOptions(
					mergedOptions,
					{
						isEnableDoubleClick: mergedOptions.isEnableDoubleClick,
						value: -1 * mergedOptions.seekValue,
						onClick: () => this.showBubble(this.ui.bubbleBackward, this.bubbleBackwardTimeoutId)
					}
				),
				player.children_.length
			);
		});
	}

	showBubble(bubbleEl, bubbleTimeoutId) {
		bubbleEl.active();
		clearTimeout(bubbleTimeoutId);
		bubbleTimeoutId = setTimeout(() => {
			bubbleEl.inactive();
		}, 300);
	}

	hide() {
		Object.keys(this.ui).forEach(key => this.ui[key].hide());
	}

	show() {
		Object.keys(this.ui).forEach(key => this.ui[key].show());
	}
}

// Register the plugin with video.js.
videojs.registerPlugin('bigControls', BigControls);
